const STORAGE_KEY_EXPANDED = 'ontology.chat-side-panel-expanded'
const STORAGE_KEY_WIDTH = 'ontology.chat-side-panel-width'

function hasLocalStorage(): boolean {
  return typeof window !== 'undefined' && 'localStorage' in window
}

/** `null` when the user has never toggled the chat page side panel. */
export function getPersistedChatSidePanelExpanded(): boolean | null {
  if (!hasLocalStorage()) return null
  const raw = window.localStorage.getItem(STORAGE_KEY_EXPANDED)
  if (raw === 'true') return true
  if (raw === 'false') return false
  return null
}

export function setPersistedChatSidePanelExpanded(expanded: boolean): void {
  if (!hasLocalStorage()) return
  window.localStorage.setItem(STORAGE_KEY_EXPANDED, String(expanded))
}

/** `null` when the user has never drag-resized the chat page side panel. */
export function getPersistedChatSidePanelWidth(): number | null {
  if (!hasLocalStorage()) return null
  const raw = window.localStorage.getItem(STORAGE_KEY_WIDTH)
  if (raw === null) return null
  const parsed = Number(raw)
  return Number.isFinite(parsed) ? parsed : null
}

export function setPersistedChatSidePanelWidth(width: number): void {
  if (!hasLocalStorage()) return
  window.localStorage.setItem(STORAGE_KEY_WIDTH, String(width))
}
